<div class="main-content pt-4 mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a class="btn btn-dark btn-sm btn-reg"> Keywords </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/offPageCampaigns/urlMapping']"
          >
            URL Mapping
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/onPage']"
          >
            On-Page
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/internalLinks/add']"
          >
            Internal Links
          </a>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/technicalQa']"
          >
            Technical QA
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/localSeo']"
          >
            Local SEO
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/offPage']"
          >
            Off-Page
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/performance']"
          >
            Performance
          </a>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card mb-0">
          <div
            class="card-header"
            style="
              background: transparent;
              border-bottom: none;
              box-shadow: none;
              padding-top: 1.5rem;
              padding-bottom: 0;
            "
          >
            <div class="d-flex align-items-start justify-content-between">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center mb-1">
                  <i
                    class="fas fa-search mr-2"
                    style="font-size: 1.5rem; color: #1a56db"
                  ></i>
                  <h3
                    class="font-weight-bold m-0"
                    style="color: #111928; font-size: 1.5rem"
                  >
                    Search Campaign
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body px-4 py-4 mb-0 shadow-sm custom-scroll-x">
            <div class="row align-items-center mt-3 flex-nowrap">
              <div class="col-3">
                <mat-form-field
                  appearance="outline"
                  class="w-100 compact-search-field"
                  subscriptSizing="dynamic"
                  floatLabel="always"
                >
                  <mat-label>Search location</mat-label>
                  <input
                    #locInput
                    #locTrigger="matAutocompleteTrigger"
                    type="text"
                    matInput
                    [(ngModel)]="selectedLocation"
                    (ngModelChange)="onLocationSearch($event)"
                    [matAutocomplete]="autoCity"
                    placeholder="Search location..."
                  />
                  <mat-autocomplete
                    #autoCity="matAutocomplete"
                    (optionSelected)="
                      selectLocation($event.option.value);
                      locTrigger.closePanel();
                      locInput.blur()
                    "
                  >
                    <mat-option
                      *ngFor="let location of filteredLocations"
                      [value]="location"
                    >
                      {{ location }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="col-3">
                <mat-form-field
                  appearance="outline"
                  class="w-100 compact-search-field"
                  subscriptSizing="dynamic"
                  floatLabel="always"
                >
                  <mat-label>Search universe</mat-label>
                  <input
                    #uniInput
                    #uniTrigger="matAutocompleteTrigger"
                    type="text"
                    matInput
                    [(ngModel)]="selectedUniverse"
                    (ngModelChange)="onUniverseSearch($event)"
                    [matAutocomplete]="autoService"
                    placeholder="Search universe..."
                  />
                  <mat-autocomplete
                    #autoService="matAutocomplete"
                    (optionSelected)="
                      selectUniverse($event.option.value);
                      uniTrigger.closePanel();
                      uniInput.blur()
                    "
                    [displayWith]="displayUniverseFn"
                  >
                    <mat-option
                      *ngFor="let universe of filteredUniverses"
                      [value]="universe"
                    >
                      {{ getUniverseLabel(universe) | titlecase }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="col-3">
                <mat-form-field
                  appearance="outline"
                  class="w-100 compact-search-field"
                  subscriptSizing="dynamic"
                  floatLabel="always"
                >
                  <mat-label>Search category</mat-label>
                  <input
                    #catInput
                    #catTrigger="matAutocompleteTrigger"
                    type="text"
                    matInput
                    [(ngModel)]="selectedCategory"
                    (ngModelChange)="onCategorySearch($event)"
                    [matAutocomplete]="autoCategory"
                    placeholder="Search category..."
                  />
                  <mat-autocomplete
                    #autoCategory="matAutocomplete"
                    (optionSelected)="
                      selectCategory($event.option.value);
                      catTrigger.closePanel();
                      catInput.blur()
                    "
                    [displayWith]="displayCategoryFn"
                  >
                    <mat-option
                      *ngFor="let category of filteredCategories"
                      [value]="category"
                    >
                      {{ getCategoryLabel(category) | titlecase }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>

              <!-- Selected Scope box -->
              <div class="col-4">
                <button
                  class="btn btn-outline-secondary btn-sm btn-filter mb-0"
                  (click)="getRecords()"
                >
                  Find
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div
            class="card-header"
            style="
              background: transparent;
              border-bottom: none;
              box-shadow: none;
              padding-top: 1.5rem;
              padding-bottom: 0;
            "
          >
            <div class="d-flex align-items-start justify-content-between">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center mb-1">
                  <i
                    class="fas fa-crosshairs mr-2"
                    style="font-size: 1.5rem; color: #1a56db"
                  ></i>
                  <h3
                    class="font-weight-bold m-0"
                    style="color: #111928; font-size: 1.5rem"
                  >
                    {{ campaignTitle }}
                  </h3>
                  <button
                    *ngIf="searched"
                    type="button"
                    class="btn btn-dark btn-add btn-sm ml-auto"
                    (click)="addKeyword()"
                  >
                    Add Keyword
                  </button>
                </div>
                <!-- <p class="text-muted m-0" style="font-size: 0.95rem">
                  Configure the market context, discovery strategy and human
                  guidance for this keyword search.
                </p> -->
              </div>

              <!-- <div
                *ngIf="!id"
                class="p-3 rounded d-flex align-items-start"
                style="
                  background-color: #f0f7ff;
                  border: 1px solid #c9dfff;
                  max-width: 450px;
                "
              >
                <i
                  class="fas fa-info-circle mr-2 mt-1"
                  style="color: #1a56db; font-size: 1.1rem"
                ></i>
                <div>
                  <strong
                    style="
                      color: #1b458b;
                      font-size: 0.95rem;
                      display: block;
                      margin-bottom: 4px;
                    "
                    >Important</strong
                  >
                  <p
                    class="mb-0"
                    style="font-size: 0.85rem; color: #1b458b; line-height: 1.4"
                  >
                    This search discovers keyword opportunities. Results will be
                    reviewed before registration. SAVE is the institutional
                    commit.
                  </p>
                </div>
              </div> -->
            </div>
          </div>
          <div class="card-body pt-0">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <!-- 1. Campaign Setup -->
              <div
                class="card p-3 mb-4 border"
                style="
                  border-radius: 8px;
                  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.02);
                  border-color: #ebf0f5 !important;
                "
              >
                <div
                  class="d-flex justify-content-between align-items-start mb-1"
                >
                  <div class="d-flex align-items-center">
                    <div
                      class="rounded-circle text-white d-flex align-items-center justify-content-center mr-3"
                      style="
                        width: 28px;
                        height: 28px;
                        font-weight: bold;
                        background-color: #2754e6;
                        font-size: 0.9rem;
                      "
                    >
                      1
                    </div>
                    <h4 class="m-0 font-weight-bold" style="color: #1a233a">
                      Campaign Setup
                    </h4>
                  </div>
                  <div style="position: relative; width: 150px">
                    <i
                      class="fas fa-lock text-muted"
                      style="
                        position: absolute;
                        right: 10px;
                        top: 10px;
                        z-index: 2;
                      "
                      *ngIf="form.get('channel')?.disabled"
                    ></i>
                    <select
                      class="form-control form-control-sm form-select"
                      id="channel"
                      formControlName="channel"
                      style="
                        border-radius: 6px;
                        border: 1px solid #ced4da;
                        height: 32px;
                        padding: 0 10px;
                      "
                    >
                      <option value="" disabled>Channel</option>
                      <option
                        *ngFor="let channel of channels"
                        [value]="channel.value"
                      >
                        {{ channel.label }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('channel')"
                    >
                      Channel is required
                    </div>
                  </div>
                </div>
                <!-- <p
                  class="text-muted mb-4"
                  style="margin-left: 44px; font-size: 0.9rem"
                >
                  Define the location and business scope for this keyword
                  search.
                </p> -->

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group pt-0" style="position: relative">
                      <label
                        class="font-weight-bold text-uppercase mb-2 text-dark"
                        style="font-size: 0.75rem; letter-spacing: 0.5px"
                        for="location"
                      >
                        Location
                        <i
                          *ngIf="!searched"
                          class="fas fa-info-circle text-muted ms-1 small pl-1"
                        ></i>
                        <i
                          class="fas fa-lock text-muted ml-1"
                          *ngIf="searched"
                        ></i>
                      </label>
                      <div
                        class="input-group"
                        style="
                          border: 1px solid #ced4da;
                          border-radius: 6px;
                          overflow: hidden;
                          height: 42px;
                        "
                      >
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text bg-white border-0"
                            style="padding: 0 12px"
                            ><i class="fas fa-search text-muted"></i
                          ></span>
                        </div>
                        <input
                          type="text"
                          class="form-control border-0 pl-0 h-100 shadow-none m-0"
                          id="location"
                          placeholder="Search location..."
                          formControlName="location"
                          (input)="findLocation()"
                          autocomplete="off"
                        />
                      </div>
                      <div
                        class="invalid-feedback d-block text-danger mt-1"
                        *ngIf="isFieldInvalid('location')"
                        style="font-size: 0.75rem"
                      >
                        Location is required
                      </div>
                      <div
                        *ngIf="resultsAvailable"
                        class="list-group position-absolute w-100 list-location"
                        style="
                          z-index: 10;
                          top: 75px;
                          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                        "
                      >
                        <button
                          type="button"
                          class="list-group-item list-group-item-action"
                          *ngFor="let result of listLocation"
                          (click)="locationSelectedAd(result)"
                        >
                          {{ result.description }}
                        </button>
                      </div>
                      <!-- <p
                        class="text-muted mt-2 mb-0"
                        style="font-size: 0.75rem; line-height: 1.3"
                      >
                        Type to search governed locations. Selection assigns.
                        Free text will not create a new location.
                      </p>-->
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group pt-0">
                      <label
                        class="font-weight-bold text-uppercase mb-2 text-dark"
                        style="font-size: 0.75rem; letter-spacing: 0.5px"
                        for="universe"
                      >
                        Universe
                        <i
                          *ngIf="!searched"
                          class="fas fa-info-circle text-muted ms-1 small pl-1"
                        ></i>
                        <i
                          class="fas fa-lock text-muted ml-1"
                          *ngIf="form.get('universe')?.disabled"
                        ></i>
                      </label>
                      <div
                        class="input-group"
                        style="
                          border: 1px solid #ced4da;
                          border-radius: 6px;
                          overflow: hidden;
                          height: 42px;
                        "
                      >
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text bg-white border-0"
                            style="padding: 0 12px"
                            ><i class="fas fa-globe text-muted"></i
                          ></span>
                        </div>
                        <!-- style="
                            background-image: none !important;
                            -webkit-appearance: none;
                            -moz-appearance: none;
                            appearance: none;
                          " -->
                        <select
                          class="form-control form-select border-0 px-2 h-100 shadow-none m-0"
                          id="universe"
                          formControlName="universe"
                          style="
                            border-radius: 6px;
                            border: 1px solid #ced4da;
                            height: 32px;
                            padding: 0 10px;
                          "
                        >
                          <option value="" disabled selected>
                            Select a universe
                          </option>
                          <option
                            *ngFor="
                              let uni of formUniverses.length
                                ? formUniverses
                                : universes
                            "
                            [value]="uni.value"
                            [ngClass]="{
                              'matched-option': matchedUniverses.has(uni.value),
                            }"
                          >
                            {{ uni.label }}
                            {{ matchedUniverses.has(uni.value) ? " ✅ " : "" }}
                          </option>
                        </select>
                        <!-- <div
                          class="input-group-append bg-white border-0 d-flex align-items-center pr-3"
                          style="pointer-events: none"
                        >
                          <i
                            class="fas fa-chevron-down text-muted"
                            style="font-size: 0.8rem"
                          ></i>
                        </div> -->
                      </div>
                      <div
                        class="invalid-feedback d-block text-danger mt-1"
                        *ngIf="isFieldInvalid('universe')"
                        style="font-size: 0.75rem"
                      >
                        Universe is required
                      </div>
                      <!-- <p
                        class="text-muted mt-2 mb-0"
                        style="font-size: 0.75rem; line-height: 1.3"
                      >
                        Courier or Runner (Task Runner Services). Governed
                        values only.
                      </p> -->
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group pt-0">
                      <label
                        class="font-weight-bold text-uppercase mb-2 text-dark"
                        style="font-size: 0.75rem; letter-spacing: 0.5px"
                        for="category"
                      >
                        Category
                        <i
                          *ngIf="!searched"
                          class="fas fa-info-circle text-muted ms-1 small pl-1"
                        ></i>
                        <i
                          class="fas fa-lock text-muted ml-1"
                          *ngIf="form.get('category')?.disabled"
                        ></i>
                      </label>
                      <div
                        class="input-group"
                        style="
                          border: 1px solid #ced4da;
                          border-radius: 6px;
                          overflow: hidden;
                          height: 42px;
                        "
                      >
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text bg-white border-0"
                            style="padding: 0 12px"
                            ><i class="fa-regular fa-folder"></i
                          ></span>
                        </div>
                        <select
                          class="form-control form-select border-0 px-2 h-100 shadow-none m-0"
                          id="category"
                          formControlName="category"
                          style="
                            border-radius: 6px;
                            border: 1px solid #ced4da;
                            height: 32px;
                            padding: 0 10px;
                          "
                        >
                          <option value="" disabled selected>
                            Select a category
                          </option>
                          <option
                            *ngFor="
                              let cat of formCategories.length
                                ? formCategories
                                : categories
                            "
                            [value]="cat.value"
                            [ngClass]="{
                              'matched-option': matchedCategories.has(
                                cat.value
                              ),
                            }"
                          >
                            {{ cat.label }}
                            {{ matchedCategories.has(cat.value) ? " ✅ " : "" }}
                          </option>
                        </select>
                        <!-- <div
                          class="input-group-append bg-white border-0 d-flex align-items-center pr-3"
                          style="pointer-events: none"
                        >
                          <i
                            class="fas fa-chevron-down text-muted"
                            style="font-size: 0.8rem"
                          ></i>
                        </div> -->
                      </div>
                      <div
                        class="invalid-feedback d-block text-danger mt-1"
                        *ngIf="isFieldInvalid('category')"
                        style="font-size: 0.75rem"
                      >
                        Category is required
                      </div>
                      <!-- <p
                        class="text-muted mt-2 mb-0"
                        style="font-size: 0.75rem; line-height: 1.3"
                      >
                        Categories depend on the selected universe. Governed
                        values only.
                      </p> -->
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group pt-0">
                      <label
                        class="font-weight-bold text-uppercase mb-2 text-dark"
                        style="font-size: 0.75rem; letter-spacing: 0.5px"
                        for="conversionGoal"
                      >
                        Conversion Goal
                        <i
                          *ngIf="!searched"
                          class="fas fa-info-circle text-muted ms-1 small pl-1"
                        ></i>
                        <i
                          class="fas fa-lock text-muted ml-1"
                          *ngIf="form.get('conversionGoal')?.disabled"
                        ></i>
                      </label>
                      <div
                        class="input-group"
                        style="
                          border: 1px solid #ced4da;
                          border-radius: 6px;
                          overflow: hidden;
                          height: 42px;
                        "
                      >
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text bg-white border-0"
                            style="padding: 0 12px"
                            ><i class="fas fa-bullseye text-muted"></i
                          ></span>
                        </div>
                        <select
                          class="form-control form-select border-0 px-2 h-100 shadow-none m-0"
                          id="conversionGoal"
                          formControlName="conversionGoal"
                          style="
                            border-radius: 6px;
                            border: 1px solid #ced4da;
                            height: 32px;
                            padding: 0 10px;
                          "
                        >
                          <option value="" disabled selected>
                            Select a conversion goal
                          </option>
                          <option
                            *ngFor="let goal of conversionGoals"
                            [value]="goal.value"
                            [ngClass]="{
                              'matched-option': matchedGoals.has(goal.value),
                            }"
                          >
                            {{ goal.label }}
                            {{ matchedGoals.has(goal.value) ? " ✅ " : "" }}
                          </option>
                        </select>
                        <!-- <div
                          class="input-group-append bg-white border-0 d-flex align-items-center pr-3"
                          style="pointer-events: none"
                        >
                          <i
                            class="fas fa-chevron-down text-muted"
                            style="font-size: 0.8rem"
                          ></i>
                        </div> -->
                      </div>
                      <div
                        class="invalid-feedback d-block text-danger mt-1"
                        *ngIf="isFieldInvalid('conversionGoal')"
                        style="font-size: 0.75rem"
                      >
                        Conversion Goal is required
                      </div>
                      <!-- <p
                        class="text-muted mt-2 mb-0"
                        style="font-size: 0.75rem; line-height: 1.3"
                      >
                        What outcome are we optimizing for with this keyword
                        search?
                      </p> -->
                    </div>
                  </div>
                </div>
              </div>

              <!-- 2. Keyword Strategy -->
              <div
                class="card p-3 mt-3 border"
                style="
                  border-radius: 8px;
                  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.02);
                  border-color: #ebf0f5 !important;
                "
              >
                <div class="d-flex align-items-center mb-1">
                  <div
                    class="rounded-circle text-white d-flex align-items-center justify-content-center mr-3"
                    style="
                      width: 28px;
                      height: 28px;
                      font-weight: bold;
                      background-color: #2754e6;
                      font-size: 0.9rem;
                    "
                  >
                    2
                  </div>
                  <h4 class="m-0 font-weight-bold" style="color: #1a233a">
                    Keyword Strategy
                  </h4>
                </div>
                <!-- <p
                  class="text-muted mb-4"
                  style="margin-left: 44px; font-size: 0.9rem"
                >
                  Define how the system should discover and evaluate keyword
                  opportunities.
                </p> -->

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group pt-0">
                      <label
                        class="font-weight-bold text-uppercase mb-2 text-dark"
                        style="font-size: 0.75rem; letter-spacing: 0.5px"
                        for="keywordIntent"
                      >
                        Keyword Intent
                        <i
                          *ngIf="!searched"
                          class="fas fa-info-circle text-muted ms-1 small pl-1"
                        ></i>
                        <i
                          class="fas fa-lock text-muted ml-1"
                          *ngIf="form.get('keywordIntent')?.disabled"
                        ></i>
                      </label>
                      <div
                        class="input-group"
                        style="
                          border: 1px solid #ced4da;
                          border-radius: 6px;
                          overflow: hidden;
                          height: 42px;
                        "
                      >
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text bg-white border-0"
                            style="padding: 0 12px"
                            ><i class="fa-regular fa-heart"></i
                          ></span>
                        </div>
                        <select
                          class="form-control form-select border-0 px-2 h-100 shadow-none m-0"
                          id="keywordIntent"
                          formControlName="keywordIntent"
                          style="
                            border-radius: 6px;
                            border: 1px solid #ced4da;
                            height: 32px;
                            padding: 0 10px;
                          "
                        >
                          <option value="" disabled selected>
                            Select intent focus
                          </option>
                          <option
                            *ngFor="let intent of keywordIntents"
                            [value]="intent.value"
                            [ngClass]="{
                              'matched-option': matchedIntents.has(
                                intent.value
                              ),
                            }"
                          >
                            {{ intent.label }}
                            {{ matchedIntents.has(intent.value) ? " ✅ " : "" }}
                          </option>
                        </select>
                        <!-- <div
                          class="input-group-append bg-white border-0 d-flex align-items-center pr-3"
                          style="pointer-events: none"
                        >
                          <i
                            class="fas fa-chevron-down text-muted"
                            style="font-size: 0.8rem"
                          ></i>
                        </div> -->
                      </div>
                      <div
                        class="invalid-feedback d-block text-danger mt-1"
                        *ngIf="isFieldInvalid('keywordIntent')"
                        style="font-size: 0.75rem"
                      >
                        Keyword Intent is required
                      </div>
                      <!-- <p
                        class="text-muted mt-2 mb-0"
                        style="font-size: 0.75rem; line-height: 1.3"
                      >
                        Mixed High-Intent = High-Intent Local + Broad Commercial
                        only.
                      </p> -->
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group pt-0">
                      <label
                        class="font-weight-bold text-uppercase mb-2 text-dark"
                        style="font-size: 0.75rem; letter-spacing: 0.5px"
                        for="keywordMode"
                      >
                        Keyword Mode
                        <i
                          *ngIf="!searched"
                          class="fas fa-info-circle text-muted ms-1 small pl-1"
                        ></i>
                        <i
                          class="fas fa-lock text-muted ml-1"
                          *ngIf="form.get('keywordMode')?.disabled"
                        ></i>
                      </label>
                      <div
                        class="input-group"
                        style="
                          border: 1px solid #ced4da;
                          border-radius: 6px;
                          overflow: hidden;
                          height: 42px;
                        "
                      >
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text bg-white border-0"
                            style="padding: 0 12px"
                            ><i class="fas fa-bullseye text-muted"></i
                          ></span>
                        </div>
                        <select
                          class="form-control form-select border-0 px-2 h-100 shadow-none m-0"
                          id="keywordMode"
                          formControlName="keywordMode"
                          style="
                            border-radius: 6px;
                            border: 1px solid #ced4da;
                            height: 32px;
                            padding: 0 10px;
                          "
                        >
                          <option value="" disabled selected>
                            Select keyword mode
                          </option>
                          <option
                            *ngFor="let mode of keywordModes"
                            [value]="mode.value"
                            [ngClass]="{
                              'matched-option': matchedModes.has(mode.value),
                            }"
                          >
                            {{ mode.label }}
                            {{ matchedModes.has(mode.value) ? " ✅ " : "" }}
                          </option>
                        </select>
                        <!-- <div
                          class="input-group-append bg-white border-0 d-flex align-items-center pr-3"
                          style="pointer-events: none"
                        >
                          <i
                            class="fas fa-chevron-down text-muted"
                            style="font-size: 0.8rem"
                          ></i>
                        </div> -->
                      </div>
                      <div
                        class="invalid-feedback d-block text-danger mt-1"
                        *ngIf="isFieldInvalid('keywordMode')"
                        style="font-size: 0.75rem"
                      >
                        Keyword Mode is required
                      </div>
                      <!-- <p
                        class="text-muted mt-2 mb-0"
                        style="font-size: 0.75rem; line-height: 1.3"
                      >
                        AI Optimized = orchestrator across supported keyword
                        mode dimensions.
                      </p> -->
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group pt-0">
                      <label
                        class="font-weight-bold text-uppercase mb-2 text-dark"
                        style="font-size: 0.75rem; letter-spacing: 0.5px"
                        for="competitionTarget"
                      >
                        Competition Target
                        <i
                          *ngIf="!searched"
                          class="fas fa-info-circle text-muted ms-1 small pl-1"
                        ></i>
                        <i
                          class="fas fa-lock text-muted ml-1"
                          *ngIf="form.get('competitionTarget')?.disabled"
                        ></i>
                      </label>
                      <div
                        class="input-group"
                        style="
                          border: 1px solid #ced4da;
                          border-radius: 6px;
                          overflow: hidden;
                          height: 42px;
                        "
                      >
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text bg-white border-0"
                            style="padding: 0 12px"
                            ><i class="fas fa-trophy text-muted"></i
                          ></span>
                        </div>
                        <select
                          class="form-control form-select border-0 px-2 h-100 shadow-none m-0"
                          id="competitionTarget"
                          formControlName="competitionTarget"
                          style="
                            border-radius: 6px;
                            border: 1px solid #ced4da;
                            height: 32px;
                            padding: 0 10px;
                          "
                        >
                          <option value="" disabled selected>
                            Select competition focus
                          </option>
                          <option
                            *ngFor="let target of competitionTargets"
                            [value]="target.value"
                            [ngClass]="{
                              'matched-option': matchedCompetitions.has(
                                target.value
                              ),
                            }"
                          >
                            {{ target.label }}
                            {{
                              matchedCompetitions.has(target.value)
                                ? " ✅ "
                                : ""
                            }}
                          </option>
                        </select>
                        <!-- <div
                          class="input-group-append bg-white border-0 d-flex align-items-center pr-3"
                          style="pointer-events: none"
                        >
                          <i
                            class="fas fa-chevron-down text-muted"
                            style="font-size: 0.8rem"
                          ></i>
                        </div> -->
                      </div>
                      <div
                        class="invalid-feedback d-block text-danger mt-1"
                        *ngIf="isFieldInvalid('competitionTarget')"
                        style="font-size: 0.75rem"
                      >
                        Competition Target is required
                      </div>
                      <!-- <p
                        class="text-muted mt-2 mb-0"
                        style="font-size: 0.75rem; line-height: 1.3"
                      >
                        Strategic Mix = orchestrator across supported
                        competition fields.
                      </p> -->
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group pt-0">
                      <label
                        class="font-weight-bold text-uppercase mb-2 text-dark"
                        style="font-size: 0.75rem; letter-spacing: 0.5px"
                        for="objective"
                      >
                        Objective
                        <i
                          *ngIf="!searched"
                          class="fas fa-info-circle text-muted ms-1 small pl-1"
                        ></i>
                        <i
                          class="fas fa-lock text-muted ml-1"
                          *ngIf="form.get('objective')?.disabled"
                        ></i>
                      </label>
                      <div
                        class="input-group"
                        style="
                          border: 1px solid #ced4da;
                          border-radius: 6px;
                          overflow: hidden;
                          height: 42px;
                        "
                      >
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text bg-white border-0"
                            style="padding: 0 12px"
                            ><i class="fas fa-chart-line text-muted"></i
                          ></span>
                        </div>
                        <select
                          class="form-control form-select border-0 px-2 h-100 shadow-none m-0"
                          id="objective"
                          formControlName="objective"
                          style="
                            border-radius: 6px;
                            border: 1px solid #ced4da;
                            height: 32px;
                            padding: 0 10px;
                          "
                        >
                          <option value="" disabled selected>
                            Select primary objective
                          </option>
                          <option
                            *ngFor="let obj of objectives"
                            [value]="obj.value"
                            [ngClass]="{
                              'matched-option': matchedObjectives.has(
                                obj.value
                              ),
                            }"
                          >
                            {{ obj.label }}
                            {{ matchedObjectives.has(obj.value) ? " ✅ " : "" }}
                          </option>
                        </select>
                        <!-- <div
                          class="input-group-append bg-white border-0 d-flex align-items-center pr-3"
                          style="pointer-events: none"
                        >
                          <i
                            class="fas fa-chevron-down text-muted"
                            style="font-size: 0.8rem"
                          ></i>
                        </div> -->
                      </div>
                      <div
                        class="invalid-feedback d-block text-danger mt-1"
                        *ngIf="isFieldInvalid('objective')"
                        style="font-size: 0.75rem"
                      >
                        Objective is required
                      </div>
                      <!-- <p
                        class="text-muted mt-2 mb-0"
                        style="font-size: 0.75rem; line-height: 1.3"
                      >
                        Strategic Growth Mix = Conversion Growth + Ranking
                        Growth only. Authority Growth is separate.
                      </p> -->
                    </div>
                  </div>
                </div>
              </div>

              <!-- 3. Landing strategy -->
              <!-- <div class="card p-4 border-cards">
                <div class="row pt-2 pb-2">
                  <div class="col-md-12">
                    <h6
                      class="text-dark font-weight-bold"
                      style="
                        font-size: 1rem;
                        border-bottom: 1px solid #dee2e6;
                        padding-bottom: 8px;
                        margin-bottom: 20px;
                      "
                    >
                      Landing & URL strategy
                    </h6>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="landingStrategy"
                        >Landing Strategy</label
                      >
                      <select
                        class="form-control form-select"
                        id="landingStrategy"
                        formControlName="landingStrategy"
                        style="pointer-events: none; background-color: #e9ecef"
                        tabindex="-1"
                      >
                        <option
                          *ngFor="let ls of landingStrategies"
                          [value]="ls.value"
                        >
                          {{ ls.label }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('landingStrategy')"
                      >
                        Landing Strategy is required
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="urlStrategy"
                        >url strategy</label
                      >
                      <select
                        class="form-control form-select"
                        id="urlStrategy"
                        formControlName="urlStrategy"
                        style="pointer-events: none; background-color: #e9ecef"
                        tabindex="-1"
                      >
                        <option
                          *ngFor="let us of urlStrategies"
                          [value]="us.value"
                        >
                          {{ us.label }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('urlStrategy')"
                      >
                        url strategy is required
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="actionType"
                        >Action Type</label
                      >
                      <select
                        class="form-control form-select"
                        id="actionType"
                        formControlName="actionType"
                        style="pointer-events: none; background-color: #e9ecef"
                        tabindex="-1"
                      >
                        <option
                          *ngFor="let act of actionTypes"
                          [value]="act.value"
                        >
                          {{ act.label }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('actionType')"
                      >
                        Action is required
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="priority"
                        >Priority</label
                      >
                      <select
                        class="form-control form-select"
                        id="priority"
                        formControlName="priority"
                      >
                        <option
                          *ngFor="let prio of priorities"
                          [value]="prio.value"
                        >
                          {{ prio.label }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('priority')"
                      >
                        Priority is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-3" *ngIf="id">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="uniqueKeywordUrls" style="font-weight: 500; color: #333;"
                        >Suggested Target URLs</label
                      >
                      <textarea
                        #textareaUrls
                        class="form-control"
                        id="uniqueKeywordUrls"
                        [value]="uniqueKeywordUrls"
                        readonly
                        style="background-color: #f8f9fa; cursor: not-allowed; overflow: hidden; min-height: 120px;"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- 3. Focus Notes -->
              <div
                class="card p-3 mt-3 border"
                style="
                  border-radius: 8px;
                  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.02);
                  border-color: #ebf0f5 !important;
                "
              >
                <div class="d-flex align-items-center mb-1">
                  <div
                    class="rounded-circle text-white d-flex align-items-center justify-content-center mr-3"
                    style="
                      width: 28px;
                      height: 28px;
                      font-weight: bold;
                      background-color: #2754e6;
                      font-size: 0.9rem;
                    "
                  >
                    3
                  </div>
                  <h4 class="m-0 font-weight-bold" style="color: #1a233a">
                    Focus Notes
                    <span
                      class="badge badge-pill badge-light text-primary ml-2 border"
                      style="
                        font-weight: 500;
                        background-color: #e5f0ff;
                        border-color: #b8d4ff !important;
                        font-size: 0.75rem;
                        padding: 4px 10px;
                        vertical-align: middle;
                      "
                      >Optional</span
                    >
                  </h4>
                </div>
                <!-- <p
                  class="text-muted mb-4"
                  style="margin-left: 44px; font-size: 0.9rem"
                >
                  Provide any additional context, priorities or guidance the AI
                  should consider.
                </p> -->

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group pt-0">
                      <div class="d-flex align-items-center mb-1">
                        <i
                          class="fas fa-lock text-muted mr-2"
                          *ngIf="form.get('notesFocus')?.disabled"
                        ></i>
                        <span
                          *ngIf="form.get('notesFocus')?.disabled"
                          class="text-muted"
                          style="font-size: 0.8rem"
                          >Focus (locked)</span
                        >
                      </div>
                      <div class="position-relative">
                        <i
                          class="far fa-sticky-note text-muted position-absolute"
                          style="top: 14px; left: 14px"
                        ></i>
                        <textarea
                          class="form-control shadow-none"
                          id="notesFocus"
                          formControlName="notesFocus"
                          rows="3"
                          placeholder="Example: Focus on B2B legal clients, medical courier demand, after-hours urgency, luxury service positioning, etc."
                          style="
                            border: 1px solid #ced4da;
                            border-radius: 6px;
                            padding-left: 40px;
                            padding-top: 10px;
                            resize: vertical;
                            min-height: 90px;
                            font-size: 0.95rem;
                          "
                        ></textarea>
                      </div>
                      <div
                        class="invalid-feedback d-block text-danger mt-1"
                        *ngIf="isFieldInvalid('notesFocus')"
                        style="font-size: 0.75rem"
                      >
                        Focus is required
                      </div>
                      <div class="text-right mt-1">
                        <small class="text-muted"
                          >{{ form.get("notesFocus")?.value?.length || 0 }} /
                          1000 characters</small
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="row" *ngIf="id">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="title">Title</label>
                    <input
                      type="text"
                      class="form-control"
                      id="title"
                      formControlName="title"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('title')"
                    >
                      Title is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="targetKeyword"
                      >Target Keyword</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="targetKeyword"
                      formControlName="targetKeyword"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('targetKeyword')"
                    >
                      Keyword is required
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="row pb-4 pt-4" *ngIf="id">
                <div class="col-md-12 d-flex align-items-center">
                  <div
                    class="text-nowrap d-inline-flex align-items-center"
                    style="
                      border: 1px solid #dee2e6;
                      border-radius: 6px;
                      padding: 4px 8px;
                      background-color: #f8f9fa;
                      gap: 2px;
                    "
                  >
                    <a
                      class="btn btn-link text-dark btn-sm"
                      [routerLink]="[
                        '/marketing/seo/offPageCampaigns/edit',
                        id,
                      ]"
                      title="Edit"
                    >
                      <i class="fas fa-pen"></i>
                    </a>

                    <button
                      type="button"
                      *ngIf="
                        form.get('status')?.value === 'planned' ||
                        form.get('status')?.value === 'research'
                      "
                      (click)="approve(id)"
                      class="btn btn-link text-success btn-sm"
                      title="Approve"
                    >
                      <i class="fas fa-check-circle"></i>
                    </button>

                    <button
                      type="button"
                      *ngIf="
                        form.get('status')?.value === 'approved' ||
                        form.get('status')?.value === 'paused'
                      "
                      (click)="changeStatus(id, 'in_progress')"
                      class="btn btn-link text-primary btn-sm"
                      title="Start"
                    >
                      <i class="fas fa-play"></i>
                    </button>

                    <button
                      type="button"
                      *ngIf="form.get('status')?.value === 'in_progress'"
                      (click)="changeStatus(id, 'paused')"
                      class="btn btn-link text-warning btn-sm"
                      title="Pause"
                    >
                      <i class="fas fa-pause"></i>
                    </button>

                    <button
                      type="button"
                      *ngIf="form.get('status')?.value === 'in_progress'"
                      (click)="complete(id)"
                      class="btn btn-link text-success btn-sm"
                      title="Complete"
                    >
                      <i class="fas fa-flag-checkered"></i>
                    </button>

                    <button
                      type="button"
                      (click)="deleteData(id)"
                      class="btn btn-link text-danger btn-sm"
                      title="Delete"
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>

                  <div class="d-flex align-items-center pl-5">
                    Status:
                    <span
                      class="badge mr-3 ml-1"
                      [ngClass]="getStatusBadgeClass(form.get('status')?.value)"
                    >
                      {{ form.get("status")?.value | uppercase }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="city"
                      >City / Area</label
                    >
                    <select
                      class="form-control form-select"
                      id="city"
                      formControlName="city"
                    >
                      <option value="">Select City</option>
                      <option *ngFor="let city of cities" [value]="city.value">
                        {{ city.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="service"
                      >Service</label
                    >
                    <select
                      class="form-control form-select"
                      id="service"
                      formControlName="service"
                    >
                      <option value="">Select Service</option>
                      <option *ngFor="let obj of services" [value]="obj.value">
                        {{ obj.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="industry"
                      >Industry</label
                    >
                    <select
                      class="form-control form-select"
                      id="industry"
                      formControlName="industry"
                    >
                      <option value="">Select Industry(optional)</option>
                      <option
                        *ngFor="let obj of industries"
                        [value]="obj.value"
                      >
                        {{ obj.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="landingType"
                      >Landing Type</label
                    >
                    <select
                      class="form-control form-select"
                      id="landingType"
                      formControlName="landingType"
                    >
                      <option value="">Select Landing Type</option>
                      <option
                        *ngFor="let type of landingTypes"
                        [value]="type.value"
                      >
                        {{ type.label }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('landingType')"
                    >
                      Landing Type is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="targetUrl"
                      >Target URL</label
                    >
                    <select
                      class="form-control form-select"
                      id="targetUrl"
                      formControlName="targetUrl"
                    >
                      <option value="">Select Target URL</option>
                      <option
                        *ngFor="let url of targetUrls"
                        [value]="url.value"
                      >
                        {{ url.label }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('targetUrl')"
                    >
                      Target URL is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="objective"
                      >Objective</label
                    >
                    <select
                      class="form-control form-select"
                      id="objective"
                      formControlName="objective"
                    >
                      <option value="">Select Objective</option>
                      <option
                        *ngFor="let obj of objectives"
                        [value]="obj.value"
                      >
                        {{ obj.label }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('objective')"
                    >
                      Objective is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="campaignType"
                      >Campaign Type</label
                    >
                    <select
                      class="form-control form-select"
                      id="campaignType"
                      formControlName="campaignType"
                    >
                      <option value="">Select Campaign Type</option>
                      <option
                        *ngFor="let type of campaignTypes"
                        [value]="type.value"
                      >
                        {{ type.label }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('campaignType')"
                    >
                      Campaign Type is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="priority"
                      >Priority</label
                    >
                    <select
                      class="form-control form-select"
                      id="priority"
                      formControlName="priority"
                    >
                      <option *ngFor="let p of priorities" [value]="p.value">
                        {{ p.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="id">
                <div class="col-md-12">
                  <label class="bmd-label-floating" for="targetAnchors"
                    >Target Anchors</label
                  >
                  <div class="row" formGroupName="targetAnchors">
                    <div class="col-md-4">
                      <h6>Corto Plazo</h6>
                      <div
                        class="form-check"
                        *ngFor="let opt of targetAnchorsOptions.shortTerm"
                      >
                        <label
                          class="form-check-label"
                          [ngClass]="{
                            'text-muted text-decoration-line-through':
                              opt.status === 'disabled',
                            'text-warning': opt.status === 'paused',
                          }"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [value]="opt.value"
                            [checked]="
                              isChecked('targetAnchors', 'shortTerm', opt.value)
                            "
                            (change)="
                              toggleCheckbox(
                                'targetAnchors',
                                'shortTerm',
                                opt.value,
                                $event
                              )
                            "
                          />
                          {{ opt.value }}
                          <small
                            *ngIf="opt.status === 'paused'"
                            class="ms-1 badge badge-warning"
                            style="font-size: 9px"
                            >paused</small
                          >
                          <small
                            *ngIf="opt.status === 'disabled'"
                            class="ms-1 badge badge-secondary"
                            style="font-size: 9px"
                            >off</small
                          >
                          <span class="form-check-sign"
                            ><span class="check"></span
                          ></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Mediano Plazo</h6>
                      <div
                        class="form-check"
                        *ngFor="let opt of targetAnchorsOptions.mediumTerm"
                      >
                        <label
                          class="form-check-label"
                          [ngClass]="{
                            'text-muted text-decoration-line-through':
                              opt.status === 'disabled',
                            'text-warning': opt.status === 'paused',
                          }"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [value]="opt.value"
                            [checked]="
                              isChecked(
                                'targetAnchors',
                                'mediumTerm',
                                opt.value
                              )
                            "
                            (change)="
                              toggleCheckbox(
                                'targetAnchors',
                                'mediumTerm',
                                opt.value,
                                $event
                              )
                            "
                          />
                          {{ opt.value }}
                          <small
                            *ngIf="opt.status === 'paused'"
                            class="ms-1 badge badge-warning"
                            style="font-size: 9px"
                            >paused</small
                          >
                          <small
                            *ngIf="opt.status === 'disabled'"
                            class="ms-1 badge badge-secondary"
                            style="font-size: 9px"
                            >off</small
                          >
                          <span class="form-check-sign"
                            ><span class="check"></span
                          ></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Largo Plazo</h6>
                      <div
                        class="form-check"
                        *ngFor="let opt of targetAnchorsOptions.longTerm"
                      >
                        <label
                          class="form-check-label"
                          [ngClass]="{
                            'text-muted text-decoration-line-through':
                              opt.status === 'disabled',
                            'text-warning': opt.status === 'paused',
                          }"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [value]="opt.value"
                            [checked]="
                              isChecked('targetAnchors', 'longTerm', opt.value)
                            "
                            (change)="
                              toggleCheckbox(
                                'targetAnchors',
                                'longTerm',
                                opt.value,
                                $event
                              )
                            "
                          />
                          {{ opt.value }}
                          <small
                            *ngIf="opt.status === 'paused'"
                            class="ms-1 badge badge-warning"
                            style="font-size: 9px"
                            >paused</small
                          >
                          <small
                            *ngIf="opt.status === 'disabled'"
                            class="ms-1 badge badge-secondary"
                            style="font-size: 9px"
                            >off</small
                          >
                          <span class="form-check-sign"
                            ><span class="check"></span
                          ></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pt-4" *ngIf="id">
                <div class="col-md-12">
                  <label class="bmd-label-floating" for="suggestedKeywords"
                    >Keywords</label
                  >
                  <div class="row" formGroupName="suggestedKeywords">
                    <div class="col-md-4">
                      <h6 class="d-flex align-items-center">
                        Corto Plazo
                        <button
                          type="button"
                          class="btn btn-sm ml-2 btn-add__kw"
                          (click)="openAddInput('kw_short')"
                        >
                          +
                        </button>
                      </h6>

                      <div class="mb-3" *ngIf="activeAddTerm === 'kw_short'">
                        <div class="input-group input-kw">
                          <input
                            type="text"
                            class="form-control px-2"
                            style="height: 30px"
                            placeholder="Keyword..."
                            #newKwShort
                            (keyup.enter)="
                              confirmAddItem(
                                'suggestedKeywords',
                                'shortTerm',
                                newKwShort
                              )
                            "
                          />
                          <div class="input-group-append">
                            <button
                              class="btn btn-info btn-sm m-0 px-2 btn-save"
                              type="button"
                              (click)="
                                confirmAddItem(
                                  'suggestedKeywords',
                                  'shortTerm',
                                  newKwShort
                                )
                              "
                            >
                              <i class="fas fa-save"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        class="form-check"
                        *ngFor="let opt of suggestedKeywordsOptions.shortTerm"
                      >
                        <label
                          class="form-check-label"
                          [ngClass]="{
                            'text-muted text-decoration-line-through':
                              opt.status === 'disabled',
                            'text-warning': opt.status === 'paused',
                          }"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [value]="opt.value"
                            [checked]="
                              isChecked(
                                'suggestedKeywords',
                                'shortTerm',
                                opt.value
                              )
                            "
                            (change)="
                              toggleCheckbox(
                                'suggestedKeywords',
                                'shortTerm',
                                opt.value,
                                $event
                              )
                            "
                          />
                          {{ opt.value }}
                          <small
                            *ngIf="opt.status === 'paused'"
                            class="ms-1 badge badge-warning"
                            style="font-size: 9px"
                            >paused</small
                          >
                          <small
                            *ngIf="opt.status === 'disabled'"
                            class="ms-1 badge badge-secondary"
                            style="font-size: 9px"
                            >off</small
                          >
                          <span class="form-check-sign"
                            ><span class="check"></span
                          ></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6 class="d-flex align-items-center">
                        Mediano Plazo
                        <button
                          type="button"
                          class="btn btn-sm ml-2 btn-add__kw"
                          (click)="openAddInput('kw_medium')"
                        >
                          +
                        </button>
                      </h6>

                      <div class="mb-3" *ngIf="activeAddTerm === 'kw_medium'">
                        <div class="input-group input-kw">
                          <input
                            type="text"
                            class="form-control px-2"
                            style="height: 30px"
                            placeholder="Keyword..."
                            #newKwMedium
                            (keyup.enter)="
                              confirmAddItem(
                                'suggestedKeywords',
                                'mediumTerm',
                                newKwMedium
                              )
                            "
                          />
                          <div class="input-group-append">
                            <button
                              class="btn btn-sm m-0 px-2 btn-save"
                              type="button"
                              (click)="
                                confirmAddItem(
                                  'suggestedKeywords',
                                  'mediumTerm',
                                  newKwMedium
                                )
                              "
                            >
                              <i class="fas fa-save"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        class="form-check"
                        *ngFor="let opt of suggestedKeywordsOptions.mediumTerm"
                      >
                        <label
                          class="form-check-label"
                          [ngClass]="{
                            'text-muted text-decoration-line-through':
                              opt.status === 'disabled',
                            'text-warning': opt.status === 'paused',
                          }"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [value]="opt.value"
                            [checked]="
                              isChecked(
                                'suggestedKeywords',
                                'mediumTerm',
                                opt.value
                              )
                            "
                            (change)="
                              toggleCheckbox(
                                'suggestedKeywords',
                                'mediumTerm',
                                opt.value,
                                $event
                              )
                            "
                          />
                          {{ opt.value }}
                          <small
                            *ngIf="opt.status === 'paused'"
                            class="ms-1 badge badge-warning"
                            style="font-size: 9px"
                            >paused</small
                          >
                          <small
                            *ngIf="opt.status === 'disabled'"
                            class="ms-1 badge badge-secondary"
                            style="font-size: 9px"
                            >off</small
                          >
                          <span class="form-check-sign"
                            ><span class="check"></span
                          ></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6 class="d-flex align-items-center">
                        Largo Plazo
                        <button
                          type="button"
                          class="btn btn-sm ml-2 btn-add__kw"
                          (click)="openAddInput('kw_long')"
                        >
                          +
                        </button>
                      </h6>

                      <div class="mb-3" *ngIf="activeAddTerm === 'kw_long'">
                        <div class="input-group input-kw">
                          <input
                            type="text"
                            class="form-control px-2"
                            style="height: 30px"
                            placeholder="Keyword..."
                            #newKwLong
                            (keyup.enter)="
                              confirmAddItem(
                                'suggestedKeywords',
                                'longTerm',
                                newKwLong
                              )
                            "
                          />
                          <div class="input-group-append">
                            <button
                              class="btn btn-sm m-0 px-2 btn-save"
                              type="button"
                              (click)="
                                confirmAddItem(
                                  'suggestedKeywords',
                                  'longTerm',
                                  newKwLong
                                )
                              "
                            >
                              <i class="fas fa-save"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        class="form-check"
                        *ngFor="let opt of suggestedKeywordsOptions.longTerm"
                      >
                        <label
                          class="form-check-label"
                          [ngClass]="{
                            'text-muted text-decoration-line-through':
                              opt.status === 'disabled',
                            'text-warning': opt.status === 'paused',
                          }"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [value]="opt.value"
                            [checked]="
                              isChecked(
                                'suggestedKeywords',
                                'longTerm',
                                opt.value
                              )
                            "
                            (change)="
                              toggleCheckbox(
                                'suggestedKeywords',
                                'longTerm',
                                opt.value,
                                $event
                              )
                            "
                          />
                          {{ opt.value }}
                          <small
                            *ngIf="opt.status === 'paused'"
                            class="ms-1 badge badge-warning"
                            style="font-size: 9px"
                            >paused</small
                          >
                          <small
                            *ngIf="opt.status === 'disabled'"
                            class="ms-1 badge badge-secondary"
                            style="font-size: 9px"
                            >off</small
                          >
                          <span class="form-check-sign"
                            ><span class="check"></span
                          ></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pt-4" *ngIf="id">
                <div class="col-md-12">
                  <label class="bmd-label-floating" for="suggestedAnchors"
                    >Suggested Anchors</label
                  >
                  <div class="row" formGroupName="suggestedAnchors">
                    <div class="col-md-4">
                      <h6>Corto Plazo</h6>
                      <div
                        class="form-check"
                        *ngFor="let opt of suggestedAnchorsOptions.shortTerm"
                      >
                        <label
                          class="form-check-label"
                          [ngClass]="{
                            'text-muted text-decoration-line-through':
                              opt.status === 'disabled',
                            'text-warning': opt.status === 'paused',
                          }"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [value]="opt.value"
                            [checked]="
                              isChecked(
                                'suggestedAnchors',
                                'shortTerm',
                                opt.value
                              )
                            "
                            (change)="
                              toggleCheckbox(
                                'suggestedAnchors',
                                'shortTerm',
                                opt.value,
                                $event
                              )
                            "
                          />
                          {{ opt.value }}
                          <small
                            *ngIf="opt.status === 'paused'"
                            class="ms-1 badge badge-warning"
                            style="font-size: 9px"
                            >paused</small
                          >
                          <small
                            *ngIf="opt.status === 'disabled'"
                            class="ms-1 badge badge-secondary"
                            style="font-size: 9px"
                            >off</small
                          >
                          <span class="form-check-sign"
                            ><span class="check"></span
                          ></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Mediano Plazo</h6>
                      <div
                        class="form-check"
                        *ngFor="let opt of suggestedAnchorsOptions.mediumTerm"
                      >
                        <label
                          class="form-check-label"
                          [ngClass]="{
                            'text-muted text-decoration-line-through':
                              opt.status === 'disabled',
                            'text-warning': opt.status === 'paused',
                          }"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [value]="opt.value"
                            [checked]="
                              isChecked(
                                'suggestedAnchors',
                                'mediumTerm',
                                opt.value
                              )
                            "
                            (change)="
                              toggleCheckbox(
                                'suggestedAnchors',
                                'mediumTerm',
                                opt.value,
                                $event
                              )
                            "
                          />
                          {{ opt.value }}
                          <small
                            *ngIf="opt.status === 'paused'"
                            class="ms-1 badge badge-warning"
                            style="font-size: 9px"
                            >paused</small
                          >
                          <small
                            *ngIf="opt.status === 'disabled'"
                            class="ms-1 badge badge-secondary"
                            style="font-size: 9px"
                            >off</small
                          >
                          <span class="form-check-sign"
                            ><span class="check"></span
                          ></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Largo Plazo</h6>
                      <div
                        class="form-check"
                        *ngFor="let opt of suggestedAnchorsOptions.longTerm"
                      >
                        <label
                          class="form-check-label"
                          [ngClass]="{
                            'text-muted text-decoration-line-through':
                              opt.status === 'disabled',
                            'text-warning': opt.status === 'paused',
                          }"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [value]="opt.value"
                            [checked]="
                              isChecked(
                                'suggestedAnchors',
                                'longTerm',
                                opt.value
                              )
                            "
                            (change)="
                              toggleCheckbox(
                                'suggestedAnchors',
                                'longTerm',
                                opt.value,
                                $event
                              )
                            "
                          />
                          {{ opt.value }}
                          <small
                            *ngIf="opt.status === 'paused'"
                            class="ms-1 badge badge-warning"
                            style="font-size: 9px"
                            >paused</small
                          >
                          <small
                            *ngIf="opt.status === 'disabled'"
                            class="ms-1 badge badge-secondary"
                            style="font-size: 9px"
                            >off</small
                          >
                          <span class="form-check-sign"
                            ><span class="check"></span
                          ></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pt-4" *ngIf="id">
                <div class="col-md-12">
                  <label class="bmd-label-floating" for="targetLocations"
                    >Target Locations</label
                  >
                  <div class="row" formGroupName="targetLocations">
                    <div class="col-md-4">
                      <h6>Corto Plazo</h6>
                      <div
                        class="form-check"
                        *ngFor="let opt of targetLocationsOptions.shortTerm"
                      >
                        <label
                          class="form-check-label"
                          [ngClass]="{
                            'text-muted text-decoration-line-through':
                              opt.status === 'disabled',
                            'text-warning': opt.status === 'paused',
                          }"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [value]="opt.value"
                            [checked]="
                              isChecked(
                                'targetLocations',
                                'shortTerm',
                                opt.value
                              )
                            "
                            (change)="
                              toggleCheckbox(
                                'targetLocations',
                                'shortTerm',
                                opt.value,
                                $event
                              )
                            "
                          />
                          {{ opt.value }}
                          <small
                            *ngIf="opt.status === 'paused'"
                            class="ms-1 badge badge-warning"
                            style="font-size: 9px"
                            >paused</small
                          >
                          <small
                            *ngIf="opt.status === 'disabled'"
                            class="ms-1 badge badge-secondary"
                            style="font-size: 9px"
                            >off</small
                          >
                          <span class="form-check-sign"
                            ><span class="check"></span
                          ></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Mediano Plazo</h6>
                      <div
                        class="form-check"
                        *ngFor="let opt of targetLocationsOptions.mediumTerm"
                      >
                        <label
                          class="form-check-label"
                          [ngClass]="{
                            'text-muted text-decoration-line-through':
                              opt.status === 'disabled',
                            'text-warning': opt.status === 'paused',
                          }"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [value]="opt.value"
                            [checked]="
                              isChecked(
                                'targetLocations',
                                'mediumTerm',
                                opt.value
                              )
                            "
                            (change)="
                              toggleCheckbox(
                                'targetLocations',
                                'mediumTerm',
                                opt.value,
                                $event
                              )
                            "
                          />
                          {{ opt.value }}
                          <small
                            *ngIf="opt.status === 'paused'"
                            class="ms-1 badge badge-warning"
                            style="font-size: 9px"
                            >paused</small
                          >
                          <small
                            *ngIf="opt.status === 'disabled'"
                            class="ms-1 badge badge-secondary"
                            style="font-size: 9px"
                            >off</small
                          >
                          <span class="form-check-sign"
                            ><span class="check"></span
                          ></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6>Largo Plazo</h6>
                      <div
                        class="form-check"
                        *ngFor="let opt of targetLocationsOptions.longTerm"
                      >
                        <label
                          class="form-check-label"
                          [ngClass]="{
                            'text-muted text-decoration-line-through':
                              opt.status === 'disabled',
                            'text-warning': opt.status === 'paused',
                          }"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [value]="opt.value"
                            [checked]="
                              isChecked(
                                'targetLocations',
                                'longTerm',
                                opt.value
                              )
                            "
                            (change)="
                              toggleCheckbox(
                                'targetLocations',
                                'longTerm',
                                opt.value,
                                $event
                              )
                            "
                          />
                          {{ opt.value }}
                          <small
                            *ngIf="opt.status === 'paused'"
                            class="ms-1 badge badge-warning"
                            style="font-size: 9px"
                            >paused</small
                          >
                          <small
                            *ngIf="opt.status === 'disabled'"
                            class="ms-1 badge badge-secondary"
                            style="font-size: 9px"
                            >off</small
                          >
                          <span class="form-check-sign"
                            ><span class="check"></span
                          ></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pt-4" *ngIf="id">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="notes">Notes</label>
                    <textarea
                      class="form-control"
                      id="notes"
                      formControlName="notes"
                      rows="6"
                    ></textarea>
                  </div>
                </div>
              </div>
-->
              <div class="row mt-4">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-outline mr-2 btn-actions"
                    (click)="goBack()"
                  >
                    Back
                  </button>
                  <button
                    *ngIf="!isViewOnly || newExistingRecord"
                    type="submit"
                    class="btn btn-dark btn-create"
                    [disabled]="form.invalid || isLoading"
                  >
                    <i
                      *ngIf="isLoading"
                      class="fas fa-spinner fa-spin me-2"
                    ></i>

                    {{ isLoading ? "Processing..." : "Search Keywords" }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-dark btn-create"
                    (click)="pru()"
                  >
                    Prueba
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
